import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/shoes.png'


const _withScopeId = n => (_pushScopeId("data-v-6eff0926"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "hero container" }
const _hoisted_3 = { class: "display-2 animate__animated animate__fadeInDown animate__delay-0s" }
const _hoisted_4 = { class: "display-6 animate__animated animate__fadeInDown animate__delay-1s" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "shoes",
  draggable: "false",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("home.title")), 1),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("home.subtitle")), 1)
      ]),
      _hoisted_5
    ])
  ]))
}